/**
 * Labels usados para representar os números de meses
 * que uma subscription e suas licenças podem permanecer
 * ativas 
 */
export const periodLabels = {
        1: "Monthly",
        2: "Bimonthly",
        3: "Quarterly",
        4: "Four-monthly",
        5: "Five-monthly",
        6: "Semiannual",
        7: "Seven-monthly",
        8: "Eight-monthly",
        9: "Nine-monthly",
        10: "Ten-monthly",
        11: "Eleven-monthly",
        12: "Annual"
    }